import { Helmet } from "react-helmet-async";

interface SEOProps {
  title?: string;
  description?: string;
  canonical?: string;
  ogImage?: string;
  noindex?: boolean;
  keywords?: string;
}

export const SEO = ({ 
  title = "Chabad Flushing | Chabad Donations | Chabad of Flushing Queens NY",
  description = "Chabad Flushing - Make a Chabad donation today! Support the Chabad of Flushing building campaign. Join our Jewish community center in Queens, NY. Tax-deductible Chabad donations welcome.",
  canonical = "https://chabaddonations.org/",
  ogImage = "https://chabaddonations.org/og-image.png",
  noindex = false,
  keywords = "Chabad, Chabad Flushing, Chabad donations, Chabad donation, donate to Chabad, Chabad of Flushing, Chabad Queens, Chabad NY"
}: SEOProps) => {
  const HelmetAny = Helmet as any;

  return (
    <HelmetAny>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Chabad Flushing - Chabad Donations" />
      
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:url" content={canonical} />
      <meta name="twitter:image" content={ogImage} />
    </HelmetAny>
  );
};
